module.exports = __webpack_public_path__ + "static/paga-82846a1a09839122175f149140dddd19.svg";